export default {
  appFullyRendered: 'appFullyRendered',
  appFirstPreview: 'appFirstPreview',
};



// WEBPACK FOOTER //
// ./src/shared/utils/performance/types.js